// src/hooks/useMaintenant.ts — SCE Issues
// L'heure courante, rafraîchie chaque minute : les « il y a 12 min » et les
// âges de l'accueil avancent sans recharger la page.

import { useEffect, useState } from 'react'

export function useMaintenant(periodeMs = 60_000): number {
  const [maintenant, setMaintenant] = useState(() => Date.now())
  useEffect(() => {
    const id = window.setInterval(() => setMaintenant(Date.now()), periodeMs)
    return () => window.clearInterval(id)
  }, [periodeMs])
  return maintenant
}
